var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-progress',_vm._b({attrs:{"id":"progress-secondary","animated":"","value":_vm.value}},'b-progress',_vm.propRest,false))}
var staticRenderFns = []

export { render, staticRenderFns }